// extracted by mini-css-extract-plugin
export var container = "_ir-0";
export var segment = "_ir-2";
export var segmentActive = "_ir-3";
export var track = "_ir-1";